// extracted by mini-css-extract-plugin
export default {"snapImagePreview":"src-views-common-components-SnapPreview-ImageSnapPreview-ImageSnapPreview__snapImagePreview--80B27"};